import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DatePickerService } from 'lib/ng2-sapmp/src/ui-components';
import { ManageInventoryService } from '../shared';
import { StatusBarModel } from 'lib/ng2-sapmp/src/ui-components/status-bar';
import { DEVICE_DEPLOYMENT_SUMMARY, CHART_CONFIG } from 'config';
import { LegendModel } from 'lib/ng2-sapmp/src/ui-components/legend/legend.model';
@Component({
  selector: 'app-device-summary',
  templateUrl: './device-summary.component.html',
  styleUrls: ['./device-summary.component.scss'],
  providers: [DatePickerService],
  encapsulation: ViewEncapsulation.None
})
export class DeviceSummaryComponent implements OnInit {
  systemFailure: boolean;
  leftLabel: string;
  rightLabel: string;
  progressChartData: Array<StatusBarModel>;
  progressChartDataForNull: Array<StatusBarModel>;
  deviceDeploymentSummary: any;
  deviceSummarymngInventory: any;
  addTileHeader: boolean;
  mdmDetails: any;
  arialabel: string;
  deviceSummary: any;
  manageProduct: any;
  fanLength: any;
  readyToSetupFansCount: any;
  @Input('data') data: any;
  kme: boolean;
  ztp: boolean;
  abm: boolean;
  omekme: boolean;
  omeztp: boolean;
  omeabm: boolean;
  oemStatus = false;
  // Separate label/ID pairs for each enrollment type
  omeAbmLabel: string;
  omeAbmId: string;
  omeKmeLabel: string;
  omeKmeId: string;
  omeZtpLabel: string;
  omeZtpId: string;
  enrollStatus: boolean;
  addpAuthority: any;
  addpAllow: boolean;
  existingDate: string;
  formSuccess = false;
  showError: boolean;
  processingFans: any;
  processingFansCount: any;
  processingFansFlag: boolean = false;
  fanInfoList: any;
  legendData: {};
  pData: Array<LegendModel> = [];
  changedisable: boolean;
  isDeviceCount: boolean;

  constructor(private router: Router, private manageInventoryService: ManageInventoryService, private dateformatter: DatePickerService) {
    this.leftLabel = 'Total devices';
    this.progressChartData = [];
    this.progressChartDataForNull = [];
    this.deviceDeploymentSummary = {};
    this.processingFansFlag = false;
  }

  ngOnInit() {
    this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if (this.mdmDetails && this.mdmDetails.productCode === 'ADDPZTE') {
      this.oemStatus = true;
    }
    this.addpAuthority = JSON.parse(sessionStorage.getItem('user')).user.addpAuthority;
    if (this.addpAuthority === 'PARTIAL') {
      this.addpAllow = false;
    }
    this.manageProduct = sessionStorage.getItem('manage-product');
    this.fanLength = sessionStorage.getItem('fanLength');
    this.fanInfoList = JSON.parse(sessionStorage.getItem('fanInfoList'));
    this.deviceSummary = DEVICE_DEPLOYMENT_SUMMARY;
    this.readyToSetupFansCount = sessionStorage.getItem('readyToSetupFansCount');
    this.processingFans = JSON.parse(sessionStorage.getItem('processingFanList'));
    this.processingFansCount = this.processingFans ? this.processingFans.length : 0;
    if (this.data.fan && this.data.fan.status) {
      this.isDeviceCount = this.data.deviceStatusSummary.length ? true : false;
      this.systemFailure = this.data.fan.status === 'ACTIVE' ? (this.data.deviceStatusSummary.length ? false : true) : false;
      this.deviceDeploymentSummary.fan = this.data.fan.fanId;
      this.deviceDeploymentSummary.fan = this.data.fan ? this.data.fan.fanId : '';
      this.deviceDeploymentSummary.accountId = this.data.fan.emmAccountId;
      if (this.data.fan.status === "PROCESSING" && this.data.fan.emmProductCode === 'DMPAABM') {
        this.deviceDeploymentSummary.accountId = "Pending";
        this.deviceDeploymentSummary.prodName = 'Apple Organization ID:';
        this.abm = true;
        this.changedisable = true;
      }
      if (this.data.fan.status === "Active" && this.data.fan.emmProductCode !== "DMPAABM") {
        this.changedisable = false;
      }
      this.deviceDeploymentSummary.prodCode = this.data.fan.emmProductCode;
      this.deviceDeploymentSummary.status = this.data.fan.status;

      if (this.data.profile && this.data.profile.communicationPref) {
        this.deviceDeploymentSummary.profile = this.data.profile;
      } else {
        let deviceSummary = JSON.parse(sessionStorage.getItem('devicesSummary'));
        let fanProfile = deviceSummary.filter(x => x.fan.fanId === this.deviceDeploymentSummary.fan && ((x.fan.status === "ACTIVE") || (x.fan.emmProductCode === "DMPAABM" && x.fan.status === 'PROCESSING')));
        this.deviceDeploymentSummary.profile = fanProfile[0].profile
        this.data.profile = fanProfile[0].profile

      }
      this.deviceDeploymentSummary.comPref = this.deviceDeploymentSummary.profile && this.deviceDeploymentSummary?.profile?.communicationPref;
      //check for showing OEM id
      if (this.fanInfoList != null) {
        for (let k = 0; k < this.fanInfoList.length; k++) {
          if (this.data.fan.fanId === this.fanInfoList[k].fan) {
            if (this.fanInfoList[k].emmProductCode === 'DMPAABM' && this.deviceDeploymentSummary.prodCode !== this.fanInfoList[k].emmProductCode && this.fanInfoList[k].accountStatus === 'ACTIVE') {
              this.omeAbmLabel = 'Apple Organization ID:';
              this.omeAbmId = this.fanInfoList[k].emmAccountId;
              this.omeabm = true;
            }
            if (this.fanInfoList[k].emmProductCode === 'DMPAABM' && this.deviceDeploymentSummary.prodCode !== this.fanInfoList[k].emmProductCode && (this.fanInfoList[k].accountStatus === "PROCESSING" || this.fanInfoList[k].accountStatus === "SIGNUP_INPROGRESS")) {
              this.omeAbmLabel = 'Apple Organization ID:';
              this.omeAbmId = "Pending";
              this.data?.deviceStatusSummary[1]?.noOfDevices;
              this.omeabm = true;
              this.changedisable = true;
            }
            if (this.fanInfoList[k].emmProductCode === 'DMPSKME' && this.deviceDeploymentSummary.prodCode !== this.fanInfoList[k].emmProductCode && this.fanInfoList[k].accountStatus === 'ACTIVE') {
              this.omeKmeLabel = 'Knox Mobile Enrollment ID:';
              this.omeKmeId = this.fanInfoList[k].emmAccountId;
              this.omekme = true;
              this.changedisable = false;
            }
            if (this.fanInfoList[k].emmProductCode === 'DMPGZTP' && this.deviceDeploymentSummary.prodCode !== this.fanInfoList[k].emmProductCode && this.fanInfoList[k].accountStatus === 'ACTIVE') {
              this.omeZtpLabel = 'GOOGLE ID:';
              this.omeZtpId = this.fanInfoList[k].emmAccountId;
              this.omeztp = true;
              this.changedisable = false;
            }
          }
        }
      }

      if (this.deviceDeploymentSummary.prodCode === 'DMPAABM' && (this.deviceDeploymentSummary.status === 'ACTIVE' || this.deviceDeploymentSummary.status === 'PROCESSING' || this.deviceDeploymentSummary.status === 'SIGNUP_INPROGRESS')) {
        this.abm = true;
        this.deviceDeploymentSummary.prodName = 'Apple Organization ID:';
      } else if (this.deviceDeploymentSummary.prodCode === 'DMPSKME' && this.deviceDeploymentSummary.status === 'ACTIVE') {
        this.kme = true;
        this.deviceDeploymentSummary.prodName = 'Knox Mobile Enrollment ID:';
        this.changedisable = false;
      } else if (this.deviceDeploymentSummary.prodCode === 'DMPGZTP' && this.deviceDeploymentSummary.status === 'ACTIVE') {
        this.ztp = true;
        this.deviceDeploymentSummary.prodName = 'GOOGLE ID:';
        this.changedisable = false;
      }
      //adding null condition.since existDeviceEffectiveDate coming as null
      if (this.data.fan.existDeviceEffectiveDate === '' || this.data.fan.existDeviceEffectiveDate === null) {
        this.enrollStatus = true;
        this.deviceDeploymentSummary.existingDevice = 'Existing Devices';
        this.deviceDeploymentSummary.existingDevicestatus = ': Do not enroll';
      } else {
        this.deviceDeploymentSummary.existingDevice = 'Existing Devices';
        this.deviceDeploymentSummary.existingDevicestatus = ': Enroll';
      }

      if (this.data.profile === null || this.data.profile.communicationPref === 'Both' || this.data.profile.communicationPref === null) {
        this.deviceDeploymentSummary.notifications = 'Notifications';
        this.deviceDeploymentSummary.notificationstatus = ': Email/Text';
      } else if (this.data.profile.communicationPref === 'Sms') {
        this.deviceDeploymentSummary.notifications = 'Notifications';
        this.deviceDeploymentSummary.notificationstatus = ': Text';
      } else if (this.data.profile.communicationPref === 'Email') {
        this.deviceDeploymentSummary.notifications = 'Notifications';
        this.deviceDeploymentSummary.notificationstatus = ': Email';
      }

      // if(this.data.fan.status === 'PROCESSING'){
      //   this.disableChangeLink = true;
      // }

      if ((this.data.fan.status === 'ACTIVE' || this.data.fan.status === 'SIGNUP_INPROGRESS' || this.data.fan.status === 'PROCESSING') && new Date(this.data.fan.newDeviceEffectiveDate) > new Date()) {
        const summaryConfig = this.deviceSummary.FUTURE_DEPLOYMENT;
        this.deviceDeploymentSummary = Object.assign({}, this.deviceDeploymentSummary, summaryConfig);
      } else {
        const summaryConfig = this.deviceSummary[this.data.fan.status];
        this.deviceDeploymentSummary = Object.assign({}, this.deviceDeploymentSummary, summaryConfig);
      }
      this.getChartData(this.data.deviceStatusSummary);
    } else {
      const summaryConfig = !this.data.btnText ? this.deviceSummary['NO_RESULT'] : this.data;
      this.deviceDeploymentSummary = Object.assign({}, this.deviceDeploymentSummary, summaryConfig);
      if (this.deviceDeploymentSummary.status === 'No Results' && (this.processingFansCount >= 1)) {
        const summaryConfig = this.deviceSummary.PROCESSING;
        this.processingFansFlag = true;
        this.deviceDeploymentSummary = Object.assign({}, this.deviceDeploymentSummary, summaryConfig);
        this.deviceDeploymentSummary.status = false;
        if (this.deviceDeploymentSummary.fan[0].emmProductCode === "DMPAABM" && (this.deviceDeploymentSummary.status === 'ACTIVE' || this.deviceDeploymentSummary.status === 'PROCESSING' || this.deviceDeploymentSummary.status === 'SIGNUP_INPROGRESS')) {
          this.abm = true;
        } else if (this.deviceDeploymentSummary.fan[0].emmProductCode === "DMPSKME" && this.deviceDeploymentSummary.status === 'ACTIVE') {
          this.kme = true;
        } else if (this.deviceDeploymentSummary.fan[0].emmProductCode === "DMPGZTP" && this.deviceDeploymentSummary.status === 'ACTIVE') {
          this.ztp = true;
        }
      } else if (this.deviceDeploymentSummary && (this.deviceDeploymentSummary.status === 'Add accounts' ||
        this.deviceDeploymentSummary.status === 'Set up accounts')) {
        this.addTileHeader = true;
      }
      this.getChartData(this.data.deviceStatusSummary);
    }
    this.addAccounts();
  }

  getChartData(deviceDetails) {
    let totalValue = 0;
    this.legendData = { left: [], right: [] };

    if (this.mdmDetails && this.mdmDetails.productCode === 'ADDPZTE') {
      this.arialabel = 'Status bar showing the number of devices claimed compared to the total number of devices.';
    }
    if (this.deviceDeploymentSummary.status === 'Processing' && this.deviceDeploymentSummary.prodCode === "DMPAABM") {
      this.deviceDeploymentSummary.hideDeviceChart = false;
    }
    if (deviceDetails && deviceDetails.length > 0) {
      deviceDetails.forEach((d) => {
        if (d.noOfDevices > 0 && d.noOfDevices !== null) {
          totalValue += d.noOfDevices;
          const chartConfig = CHART_CONFIG[d.status];
          // if (chartConfig.label === 'not claimed') {
          //   chartConfig.label = 'Not claimed';
          // }
          if (chartConfig.label === 'enrolled, active') {
            chartConfig.label = 'Enrolled, active';
          } else if (chartConfig.label === 'not compliant') {
            chartConfig.label = 'Not compliant';
          } else if (chartConfig.label === 'enrolled, not active') {
            chartConfig.label = 'Enrolled, not active';
          } else if (chartConfig.label === 'not enrolled') {
            chartConfig.label = 'Not enrolled';
          }
          const temp: StatusBarModel = {
            'value': d.noOfDevices,
            'color': chartConfig.color,
            'legend': d.noOfDevices + ' ' + chartConfig.label,
            'ariaLabel': this.arialabel
          };
          this.progressChartData.push(temp);
        }
      });
      let count = 0;
      let tempChartData = []
      tempChartData = this.progressChartData.filter(function (x, i) {
        if (x.value > 0 && (x.legend.indexOf("claimed (Apple)") > -1 || x.legend.indexOf("claimed (Samsung)") > -1 || x.legend.indexOf("claimed (Android™)") > -1 || x.legend.indexOf("claimed (Android)") > -1)) {
          count += x.value;
        } return (x.value > 0 && x.legend.indexOf("claimed (Apple)") <= -1 && x.legend.indexOf("claimed (Samsung)") <= -1 && x.legend.indexOf("claimed (Android™)") <= -1 && x.legend.indexOf("claimed (Android)") <= -1)
      })
      this.progressChartData = tempChartData;
      if (count > 0) {
        const chartConfigClaim = CHART_CONFIG["CLAIM_SUCCESS"];
        const claimMerge: StatusBarModel = {
          'value': count,
          'color': chartConfigClaim.color,
          'legend': count + ' ' + chartConfigClaim.label,
          'ariaLabel': this.arialabel
        };
        this.progressChartData.push(claimMerge);
      }
      let arr = [];
      let arr4 = this.progressChartData.filter(x => x.legend.indexOf("claimed") > -1 && x.legend.indexOf("not claimed") < 0)
      if (arr4.length > 0) {
        arr.push(arr4.pop())
      }
      let arr3 = this.progressChartData.filter(x => x.legend.indexOf("claim pending") > -1 && x.legend.indexOf("unclaim pending") < 0)
      if (arr3.length > 0) {
        arr.push(arr3.pop())
      }
      let arr2 = this.progressChartData.filter(x => x.legend.indexOf("unclaim pending") > -1)
      if (arr2.length > 0) {
        arr.push(arr2.pop())
      }
      let arr1 = this.progressChartData.filter(x => x.legend.indexOf("not claimed") > -1)
      if (arr1.length > 0) {
        arr.push(arr1.pop());
      }

      this.progressChartData = arr;
      let legendCounter = 0;
      this.progressChartData.forEach((x, i) => {
        // if legendcounter is even, show legend on the left else on the right
        this.legendData[legendCounter % 2 === 0 ? 'left' : 'right'].push(x);
        legendCounter++;

      })

      this.rightLabel = String(totalValue);
    }
  }

  selectedFan(fan, accountid) {
    // let fanId;
    // let accountId;
    // if (fan === this.deviceDeploymentSummary.fan, accountid === this.deviceDeploymentSummary.accountId) {
    //   fanId = this.data.fan ? this.data.fan.fanId : '';
    //   this.deviceDeploymentSummary.fan = this.data.fan ? this.data.fan.fanId : '';
    //   accountId = this.data.fan ? this.data.fan.emmAccountId : '';
    //   this.deviceDeploymentSummary.accountId = this.data.fan ? this.data.fan.accountId : '';
    // }
    // this.manageInventoryService.setSelectedfan(fanId,accountId);
    //this.deviceDeploymentSummary.accountId = this.data.fan.emmAccountId;
    if (fan === this.deviceDeploymentSummary.fan) {
      this.deviceDeploymentSummary.fan = fan;
      this.deviceDeploymentSummary.accountId = accountid
      this.manageInventoryService.setSelectedfan(fan, accountid);
    }

  }
  selectedProfile(fan, profile, notifystatus) {
    let profileId;
    let fanId;
    let notifystatusid;
    if (fan === this.deviceDeploymentSummary.fan, profile === this.deviceDeploymentSummary.profile, notifystatus === this.deviceDeploymentSummary.notificationstatus) {
      profileId = this.data.profile ? this.data.profile.profileId : '';
      fanId = this.data.fan ? this.data.fan.fanId : '';
      this.deviceDeploymentSummary.fan = this.data.fan ? this.data.fan.fanId : '';
      notifystatusid = this.data.profile.communicationPref ? this.deviceDeploymentSummary.notificationstatus : '';

    }
    this.manageInventoryService.setSelectedProfilefan(fanId, profileId, notifystatusid);
  }
  // selectedProfile(profile) {
  //   let profileId;
  //   if (profile === this.deviceDeploymentSummary.profile) {
  //     profileId = this.data.profile ? this.data.profile.profileId : '';
  //   }
  //   this.manageInventoryService.setSelectedProfileID(profileId);
  // }
  viewProfile(profile) {
    let profileId;
    if (profile === this.deviceDeploymentSummary.profile) {
      profileId = this.data.profile.profileId;
    }
    sessionStorage.setItem('fanID', this.deviceDeploymentSummary.fan);
    this.manageInventoryService.setSelectedProfileID(profileId);
    this.router.navigate(['manageInventory/fanDeploymentProfile']);
  }
  updateExistingDate() {
    let fanId = this.deviceDeploymentSummary.fan;
    let minDate = new Date();
    this.existingDate = this.dateformatter.formatDate('yyyy-mm-dd', new Date(minDate.getFullYear(), minDate.getMonth(), (minDate.getDate() + 1)));
    let checkdata = {
      "fan": fanId,
      "existingDate": this.existingDate
    }
    this.manageInventoryService.postExistingDate(checkdata)
      .subscribe(
        res => {
          if (res.status === 'success') {
            this.formSuccess = true;
            this.enrollStatus = false;
            //this.deviceDeploymentSummary.success = 'Success';
            this.deviceDeploymentSummary.successMsg = 'Enroll existing device request received successfully';
          } else {
            this.showError = true;
            this.deviceDeploymentSummary.errorMsg = 'Enroll existing device request failed. Check entry and retry. If issue continues, contact support at 866.563.4703 .';
          }

        }), error => {
          //  alert("error");
          this.showError = true;

        };
  }

  navigate(deviceDeploymentSummary) {
    let url = deviceDeploymentSummary.btnAction;
    if (url === 'manageInventory/deviceInventory') {
      this.manageInventoryService.setSelectedFan(deviceDeploymentSummary.fan);
    } else if (url === 'signupsetup' && (this.mdmDetails && this.mdmDetails.productCode === 'ADDPZTE')) {
      url = 'productselection';
    }
    if (url === 'welcome' && (this.processingFansCount >= 1)) {
      url = 'productselection';
      deviceDeploymentSummary.btnParam = {};
    } else if (url === 'welcome' && this.fanLength > 0) {
      if (this.mdmDetails && this.mdmDetails.productCode === 'ADDPZTE') {
        url = 'productselection';
        deviceDeploymentSummary.btnParam = {};
      }
      else {
        url = 'productselection';
        deviceDeploymentSummary.btnParam = {};
      }
    }
    this.router.navigate([url], { queryParams: deviceDeploymentSummary.btnParam });
  }

  addAccounts() {
    var awaitingSignupFan = JSON.parse(sessionStorage.getItem('signupFanList')).length;
    const temp: LegendModel = {
      'value': awaitingSignupFan,
      'color': "#6fa8d0",
      'legend': awaitingSignupFan + " available to add",
    };
    this.pData.push(temp);
  }
}
